export default __webpack_public_path__ + "9414d9b9f585eb38d99dad69de4427c4.png";